import PricingCard from "@components/BasicComponents/Cards/PricingCard/PricingCard"
import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import CustomSelect, {
	option,
} from "@components/Theme/Select/CustomSelect/CustomSelect"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import checkIfLinkIsCurrent from "@components/WebsiteRevamp/utils/checkIfLinkIsCurrent"
import {Currencies} from "@config/currencies"
import {
	AdvancedSideAssetModuleType,
	PricingCardModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import {useRouter} from "next/router"
import React, {useState} from "react"

import styles from "./PackagesSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
	cards: PricingCardModuleType[]
	disableCurency?: boolean
	best: number
	additionalButton?: {
		title: string
		link: string
		index: number
	}
	plans: Array<{
		link: string
		title: string
	}>
}

const PackagesSection = (props: Props) => {
	const currencies = Currencies()
	const router = useRouter()

	const [activeCurrency, setActiveCurrency] = useState<string>("eur")

	const handleSelect = (selectedOptions: {[key: string]: string[]}) => {
		setActiveCurrency(selectedOptions.currencies?.[0])
	}

	const currencyActive = currencies.find(
		(element: option) => element.slug === activeCurrency,
	)

	// const amount =
	// 	props.cards.length === 1
	// 		? styles.one
	// 		: props.cards.length === 2
	// 		? styles.two
	// 		: props.cards.length === 3
	// 		? styles.three
	// 		: props.cards.length === 4
	// 		? styles.four
	// 		: ""
	const amount = styles.four
	const cardsContainer = `${styles.card} ${amount}`

	return (
		<section id={"book-a-demo"}>
			<FullWidthHeader
				data={{
					title: props.data.sectionTitle,
					subtitle: props.data.sectionSubtitle,
				}}
				position={"left"}
			/>
			<ContainerWrapper>
				{/* <Typography
						className={styles.title}
						content={props.data.sectionTitle}
						variant={Variant.SectionTitle}
						as={"h1"}
					/>
					<Typography
						className={styles.title}
						content={props.data.sectionSubtitle}
						variant={Variant.SectionSubtitle}
						style={{maxWidth: "1023px"}}
					/>
					<Separator /> */}

				{!props?.disableCurency && (
					<>
						<Separator size={16} />

						<div className={styles.currencyBox}>
							{/* <div className={styles.planTitleContainer}>
						{props.plans.map((item, index) => {
							const {current} = checkIfLinkIsCurrent(
								router.asPath,
								item.link,
							)

							return (
								<ButtonComponent
									buttonType={"text"}
									key={`plan-${index}-${item?.title}`}
									asLink
									scroll={false}
									link={item.link}
								>
									<Typography
										key={index}
										className={`${styles.planTitle} ${
											current ? styles.active : ""
										} `}
										content={item.title}
										size={Size.S}
										variant={Variant.SectionTitle}
									/>
								</ButtonComponent>
							)
						})}
					</div> */}

							<CustomSelect
								activeValue={[activeCurrency]}
								className={styles.select}
								enableAll={false}
								name={"currencies"}
								options={currencies}
								selectMenuClass={styles.selectMenuClass}
								onChange={handleSelect}
							/>
						</div>
					</>
				)}
				<Separator size={64} />

				<div className={styles.cardsContainer}>
					{props.cards.map((_, index) => {
						if (props.best === index + 1) {
							return (
								<div
									key={`recomended-${index}`}
									className={`${styles.cardRecomended} ${styles.main} ${amount}`}
								>
									<Typography
										className={`${styles.titleRecomended}  ${styles.main} `}
										content={"Recommended"}
										fontWeight={700}
										size={Size.XS}
										variant={Variant.Title}
										contrast
									/>
								</div>
							)
						}
						return (
							<div
								key={`recomended-${index}`}
								className={`${styles.cardRecomended} ${amount}`}
							>
								<div className={`${styles.titleRecomended}`} />
							</div>
						)
					})}
				</div>
				<div className={styles.cardsContainer} id={"packages"}>
					{props.cards.map((card, index) => {
						return (
							<PricingCard
								key={`pricecard-${index}-${card?.title}`}
								className={`${cardsContainer}`}
								additionalButton={
									props.additionalButton &&
									index === props.additionalButton.index
										? {...props.additionalButton}
										: undefined
								}
								color={
									props.best === index + 1
										? "main"
										: "default"
								}
								currency={currencyActive}
								data={card}
							/>
						)
					})}
				</div>
				<Paragraph
					className={styles.packagesDesc}
					content={props.data.sectionBottomTitle}
					size={"XS"}
				/>

				{props.data.sectionBottomButton &&
					props.data.sectionBottomButtonLink && (
						<>
							<Separator />
							<ButtonContainer>
								<ButtonComponent
									asLink
									link={props.data.sectionBottomButtonLink}
								>
									{props.data.sectionBottomButton}
								</ButtonComponent>
							</ButtonContainer>
						</>
					)}
				<Separator size={128} />
			</ContainerWrapper>
		</section>
	)
}

export default PackagesSection
